import axios from "axios";

export const GET_CATEGORIES = "GET_CATEGORIES";

export const getCategories = () => {
  return async (dispatch) => {
    return await axios
      .get(process.env.REACT_APP_SERVER_URL + `/api/categoRest/getall/cate`)
      .then((res) => {
        dispatch({ type: GET_CATEGORIES, payload: res.data });
      })
      .catch((err) => console.log(err));
  };
};
